<template>
  <div class="level-selector">
    <v-layout row>
      <v-flex sm6 v-if="showExerciseList">

       <!-- STANDARD / USER LEVEL SELECT TOGGLE -->
        <v-flex md12>
          <StandardUserLevelToggle />
        </v-flex>
        <!-- END STANDARD / USER LEVEL TOGGLE -->

        <!-- STANDARD EXERCISE LIST -->

          <StandardLevelsList @newLevelSelected="showLevelInfo($event)" v-if="showLevels === 'standard'"/>

        <!-- END STANDARD EXERCISE LIST -->

        <!-- USER EXERCISE LIST -->

           <UserLevelsList @newLevelSelected="showLevelInfo($event)" v-if="showLevels === 'user'"/>
         
        <!-- END USER EXERCISE LIST -->
     
      </v-flex>

      <!-- LEVEL DESCRIPTION AREA -->
      <v-flex v-if="showExerciseDescription" sm6 class="pa-3">
        <LevelDescriptionArea />
      </v-flex>
       <!-- END LEVEL DESCRIPTION AREA -->
    </v-layout>
    
  </div>
</template>

<script>
import StandardUserLevelToggle from '@/components/levelselector/StandardUserLevelToggle';
import StandardLevelsList from '@/components/levelselector/StandardLevelsList';
import UserLevelsList from '@/components/levelselector/UserLevelsList';
import LevelDescriptionArea from '@/components/levelselector/LevelDescriptionArea';
export default {
  name: 'levelSelector',
  components: {
    StandardUserLevelToggle,
    StandardLevelsList,
    UserLevelsList,
    LevelDescriptionArea
  },
  data() {
    return {
      title: 'Identify Chords Exercises', 
      levelTitle: null,
      levelDescription: null
    }
  },
  methods: {
   
  },
  computed: {
    showLevels() {
      return this.$store.getters.getShowLevels; 
    },
    breakpoint() {
      return this.$vuetify.breakpoint;
    },
    showExerciseDescription() {
      return this.$store.getters.getShowExerciseDescription;
    },
    showExerciseList() {
      return this.$store.getters.getShowExerciseList;
    }
  },
  created() {
          if (this.breakpoint.width < 600) {
        // Small screen
        this.$store.dispatch('setShowExerciseList', true);
        this.$store.dispatch('setShowExerciseDescription', false);
      } else {
        // Not small screen
        this.$store.dispatch('setShowExerciseList', true);
        this.$store.dispatch('setShowExerciseDescription', true);
      }
  }
}
</script>

<style>
</style>
